<div class="grid-container full">
  <div class="grid-x question-cell no-margin">
    @switch (true) {
      @case (showAll) {
        <div class="cell large-6 medium-6 small-6">
          <span class="bold padding-right">
            Application Number:
          </span>
          {{applicationNumber}}
        </div>
        <div class="cell large-6 medium-6 small-6">
          <span class="bold padding-right">
            Company Name:
          </span>
          {{organizationName}}
        </div>
        <div class="cell large-6 medium-6 small-6">
          <span class="bold padding-right">
            Well Name:
          </span>
          {{wellName}}
        </div>
        <div class="cell large-6 medium-6 small-6">
          <span class="bold padding-right">
            Well Number:
          </span>
          {{wellNumber}}
        </div>
      }
      @case (hasWellName == true && hasWellNumber == false) {
        <div class="cell large-6 medium-6 small-6">
          <span class="bold padding-right">
            Application Number:
          </span>
          {{applicationNumber}}
        </div>
        <div class="cell large-6 medium-6 small-6">
          <span class="bold padding-right">
            Company Name:
          </span>
          {{organizationName}}
        </div>
        <div class="cell large-12 medium-12 small-12">
          <span class="bold padding-right">
            Well Name:
          </span>
          {{wellName}}
        </div>
      }
      @case (hasWellName == false && hasWellNumber == true) {
        <div class="cell llarge-6 medium-6 small-6">
          <span class="bold padding-right">
            Application Number:
          </span>
          {{applicationNumber}}
        </div>
        <div class="cell large-6 medium-6 small-6">
          <span class="bold padding-right">
            Company Name:
          </span>
          {{organizationName}}
        </div>
        <div class="cell large-12 medium-12 small-12">
          <span class="bold padding-right">
            Well Number:
          </span>
          {{wellNumber}}
        </div>
      }
      @case (showApplicationNumberAndCompanyOnly) {
        <div class="cell large-6 medium-6 small-6">
          <span class="bold padding-right">
            Application Number:
          </span>
          {{applicationNumber}}
        </div>
        <div class="cell large-6 medium-6 small-6">
          <span class="bold padding-right">
            Company Name:
          </span>
          {{organizationName}}
        </div>
      }
    }
    @if (reviewStatus) {
      <div class="cell small-12">
        <h3 class="h4"><strong>Review Status: {{reviewStatus}}</strong></h3>
      </div>
    }
    @if (anyPending) {
      <div class="pending-warning padding-all flex align-items-center margin-bottom-large" role="alert">
        <svg-icon icon="icon-alert" aria-hidden="true" class="x-large margin-right"></svg-icon>
        <span><strong>Warning: Your application has required items pending, please see below.</strong></span>
      </div>
    }
    <div class="cell small-12">
      Any fields with a <svg-icon aria-hidden="true" icon="icon-delta" class="tiny light-blue"></svg-icon> had an initial value and were changed.  Hover over the icon to see the original value.
    </div>
    <!-- Section -->
    @for (section of displaySections; track section; let i = $index; let o = $odd; let e = $even) {
      <div class="cell small-12 margin-bottom-large" [ngClass]="{'medium-padding-left': o,'medium-padding-right': e}">
        @if (section.showHeading) {
          <div class="flex align-items-center section-heading minor-margin-bottom" [ngClass]="{'pending': section.isPending}" [attr.role]="section.isPending ? 'alert': null">
            <span class="minor-margin-right flex-grow-1"><strong>{{section.displayHeading}}</strong></span>
            <button class="linkButton" attr.aria-label="View Section '{{section.displayHeading}}'" (click)="navigateSection(section)">{{ getLinkText() }}</button>
          </div>
        }
        <!-- Summary -->
        @for (summary of section.summaryItems; track summary; let o = $odd) {
          <ul class="no-list-style no-margin-bottom minor-margin-left">
            <li [ngClass]="{ 'pending': summary.isPending, 'gray-background': o && summary.contextValue, 'padded-li' : summary.contextValue}">
              <summary-item [question]="summary" [isPreview]="isPreview" [noteIcon]="getNoteIcon(summary.contextValue)"></summary-item>
            </li>
          </ul>
        }
        <!-- Context -->
        @for (summary of section.contextItems; track summary) {
          <ul class="no-list-style minor-margin-bottom minor-margin-left">
            @if (summary.isDisplayed) {
              <li class="cell small-12 flex align-items-center" [ngClass]="{'pending': summary.isPending}">
                <div>
                  <span [attr.role]="summary.isPending ? 'alert': null" [ngClass]="{ 'pending': summary.isPending }">
                    <label class="inline"><strong>{{summary.summaryDisplay}} </strong></label>{{ getQuestionValue(summary.contextValue) }}
                    @if (summary.isPending) {
                      <span class="show-for-sr">Missing Required Information!</span>
                    }
                  </span>
                  @if (summary.isPending) {
                    <svg-icon aria-hidden="true" icon="icon-alert" class="small minor-margin-left" [attr.role]="summary.isPending ? 'alert': null"></svg-icon>
                  }
                  @if (canShowNote(summary)) {
                    <button class="minor-margin-left" attr.aria-label="Show Note For '{{summary.summaryDisplay}}'" (click)="addNote($event, summary.contextValue)">
                      <svg-icon class="note-icon cursor-pointer" [icon]="getNoteIcon(summary.contextValue)"></svg-icon>
                    </button>
                  }
                </div>
              </li>
            }
          </ul>
        }
      </div>
    }
  </div>
</div>
